import React, { useState, useEffect } from "react";

import { isMobileOnly } from 'react-device-detect';

import DateUtil from "../../common/dateUtil";

import LoadingComp from "../common/LoadingComp";

import PoliticalSearchCriteriaComp from "./PoliticalSearchCriteriaComp";
import PoliticalGridComp from "./PoliticalGridComp";
import PoliticalListComp from "./PoliticalListComp";

import PoliticalDetailComp from "./PoliticalDetailComp";

import { HandleStatusCodeThenJson } from "../../common/FetchHelpers";
import { fetchCall } from "../../common/FetchHelpers";

const PoliticalSearchComp = (props)=>{

  const searchUrl = "api/political/search";
  const detailUrl = "api/political/details/";

  let initFromDate = new Date(new Date());
  initFromDate.setDate(initFromDate.getDate() - 90);
  
    const fromDateStr = DateUtil.toIsoStrDate(initFromDate);
    
    const initFormData = {
      fromDate: fromDateStr,
      toDate: DateUtil.toIsoStrDate(new Date()),
      reqStatus: "APPROVED,PENDING,REJECTED",
      contribTypes:"Contribution,Donation"
    };
    
    const [reloadResult, setReloadResult] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState(initFormData);
    
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    
    
    
    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    
    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });
  
    const searchItems = (jsonData) => {
        setLoading(true);
        setSearchCriteria(jsonData);

        const fetchConfig = {
          method: "POST",
          cache: "no-cache",
          headers: {
            "Content-Type": "application/json"
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify(jsonData),
        };

        fetchCall(searchUrl,fetchConfig) 
          .then((result)=>{
            setDataFrame({ startIndex: 0, limit: 10 });
            setItems(result);
              setLoading(false);
              setShowResult(true);
              setReloadResult(false);
          },
          (err)=>{
            setLoading(false);
          }
        );
      };



    const onSearch = (criteria) => {
        setShowResult(false);
    
        searchItems(criteria);
      };
    
      const detailClickHandler = (id) => {
        setShowResult(false);
        setLoading(true);
        const url = detailUrl + id;

        fetchCall(url)
          .then((result)=>{
            result.formData = JSON.parse(result.formData);
            result = {...result, ...result.formData}
            console.log(result);
            setLoading(false);
            setCurrentItem(result);
            setShowDetail(true);
          },
          (err)=>{
            setLoading(false);
          }
        );
      };


      const handleReloadItem =(id)=>{
        console.log("Reloading {id}",id);
        const url = detailUrl + id;

        fetchCall(url)
          .then((result)=>{
            result.formData = JSON.parse(result.formData);
            result = {...result, ...result.formData}

            console.log(result);
            setCurrentItem(result);
            setReloadResult(true);
          },
          (err)=>{
            console.log(err);
          }
        );
      };

      const handleCloseDetail = () => {
        setShowDetail(false);
        if(reloadResult){
          onSearch(searchCriteria);
        } else{
          setShowResult(true);
        }
      };
    


      useEffect(() => {
        searchItems(initFormData);
        if(props.politicalId){
          detailClickHandler(props.politicalId);
        }
      }, []);

      useEffect(() => {
        if(props.politicalId){
          detailClickHandler(props.politicalId);
        }
      }, [props.t]);
    




    return (
        <div>
            {!showDetail && <PoliticalSearchCriteriaComp onSearch={onSearch}/>}
            
            {showResult && !showDetail &&(
                <div>
                {
                    isMobileOnly && <PoliticalListComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />
                }
                {
                    !isMobileOnly && <PoliticalGridComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />
                }

                </div>
            )}

            {showDetail && (
                    <PoliticalDetailComp
                    data={currentItem}
                    title="Details"
                    reloadItem={handleReloadItem}
                    handleUpdate={p=>props.handleUpdate(currentItem)}
                    handleClose={handleCloseDetail}
                    />
                )}

            {loading && <LoadingComp />}

        </div>
    );
}


export default PoliticalSearchComp;
